import { Fetch, FetchAttachment } from '../Models/shared/general';


//#region ======== ACTIONS ========
const actions = {
    //======== TASKS MANAGEMENT ======
    otp_new_create        : "otp_new_create",
    otp_get_mobile        : "otp_get_mobile",
    otp_update_status     : "otp_update_status"
    
};
//#endregion

//#region ========== API FUNCTIONS ===========
export async function otp_new_create(data){
    return Fetch({ action: actions.otp_new_create, data: data });
}
export async function otp_get_mobile(data){
    return Fetch({ action: actions.otp_get_mobile, data: data });
}
export async function otp_update_status(data){
    return Fetch({ action: actions.otp_update_status, data: data });
}